import React, { useState } from "react";

import { login } from "@services/api";

import { useAppStore } from "@store/appStateStore";

import "./LoginWindow.css";

const LoginWindow: React.FC = () => {
  const { setAuthenticated, setUser, setTab } = useAppStore();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.SubmitEvent) => {
    e.preventDefault();
    try {
      const result = await login(username, password);
      if (result.success && result.role) {
        setAuthenticated(result.success);
        setUser(result.role);
        setTab("home");
      } else {
        setError(result.message || "Неверный логин или пароль");
      }
    } catch (err) {
      setError("Ошибка авторизации");
      console.error("Ошибка авторизации:", err);
    }
  };

  return (
    <div className="login-window">
      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            placeholder="Логин"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="control"
          />
        </div>
        <div>
          <input
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="control"
          />
        </div>
        <div>
          <button type="submit" className="control">
            Войти
          </button>
        </div>
        {error && <div className="error">{error}</div>}
      </form>
    </div>
  );
};

export default LoginWindow;
